import * as React from 'react'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'

import { useHandleUpgradeOrExtension } from '../use-handle-upgrade-or-extension'
import { UPGRADE_SOURCES } from 'payments/upgrade-sources'
import { AUTO_OPEN_DELAY } from '../config'
import {
  getImageProps,
  getPopupTexts,
  injectBasillionFont,
  removeBasillionFont,
  shouldShowPopup,
} from '../utils'
import { Modal } from '../modal'
import { useTranslations } from '../../../contexts/header-config-context'

const LOGGED_IN_TRIAL_VARIANT = 1

export function PromoPopupLoggedInTrial({
  isOpen,
  setIsOpen,
  stripeCustomerId,
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  stripeCustomerId: string | null
}) {
  const t = useTranslations()
  const { handleUpgradeOrExtension, error, externalUrl, success, isProcessing } =
    useHandleUpgradeOrExtension('LOGGED_IN_TRIAL', UPGRADE_SOURCES.MARKETPLACE_ACTIVE_TRIAL_POPUP)
  React.useEffect(() => {
    injectBasillionFont()

    const timeout = setTimeout(() => {
      if (shouldShowPopup('LOGGED_IN_TRIAL')) {
        setIsOpen(true)
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_VIEWED, {
          type: 'Logged In Trial',
        })
      }
    }, AUTO_OPEN_DELAY)

    return () => {
      clearTimeout(timeout)
      removeBasillionFont()
    }
  }, [setIsOpen])

  const { title, description, buttonText } = getPopupTexts({ promoPopupType: 'LOGGED_IN_TRIAL', t })

  return (
    <Modal
      backgroundColor="bg-[#00CCCC]"
      error={error}
      success={success}
      externalUrl={externalUrl}
      title={title}
      description={description}
      buttonText={buttonText}
      imageProps={getImageProps('LOGGED_IN_TRIAL', LOGGED_IN_TRIAL_VARIANT)}
      promoPopupType="LOGGED_IN_TRIAL"
      onClick={() => handleUpgradeOrExtension(stripeCustomerId)}
      onClose={() => {
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_CLOSED, {
          type: 'logged-in-trial',
        })
        window.location.reload()
      }}
      isProcessing={isProcessing}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  )
}
